import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SortOptions from "@components/Navigation/SortOptions";

@inject("store")
export default class TopFilterToolbarSort extends React.Component {

    constructor(props) {
        super(props);
        this.navigateToSiteUrl = this.navigateToSiteUrl.bind(this);
        this.handleSelectedChanged = this.handleSelectedChanged.bind(this);
        this.toggleOptions = this.toggleOptions.bind(this);
        this.closeOptions = this.closeOptions.bind(this);

        this.state = {
            openOptions: false
        }

    }

    toggleOptions() {
        this.setState({
            openOptions: !this.state.openOptions
        });
    }

    navigateToSiteUrl(e, node) {
        e.preventDefault();
        const navigation = this.props.store.navigation;
        navigation.navigateToSiteUrl(navigation.mainTree, node.Url, node.Name);
    }

    facetValueRenderer = (selected, options) => {
        return "";
    }
    handleSelectedChanged(facetName, selected) {
        //console.log("facet handleSelectedChanged:", facetName, selected);
        const navigation = this.props.store.navigation;
        navigation.setFacetValue(facetName, selected);
    }

    closeOptions(event) {
        if (event.target === this.refs.sortOptionsClose) {
            this.setState({
                openOptions: false
            });
        }
    }

    componentDidMount() {
        window.addEventListener("click", this.closeOptions);
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.closeOptions);
    }

    render() {
        const navigation = this.props.store.navigation;
        const breadCrumbNodes = navigation.getNodes(navigation.NodePath);
        const facets = navigation.facets;

        const currentSortOption = navigation.getSortOptions().find(function (option) {
            return option.Value === navigation.sortOrder;
        });

        return (
            <div ref="sortOptions" className="sort-container" onClick={() => this.toggleOptions()}>
                {this.state.openOptions && <div ref="sortOptionsClose" className="sortOptionsOutside" />}
                <div className="current-sort-button">
                    <span className="sort-by">{navigation.dictionary.SortBy}</span>&nbsp;<span className="current-sort">{currentSortOption && currentSortOption.Name}</span>
                    <div className={this.state.openOptions ? "arrow-down open" : "arrow-down "}>&gt;</div>
                </div>

                {this.state.openOptions &&
                    <React.Fragment>

                        <div className="sort-options">
                            <SortOptions />
                        </div>
                    </React.Fragment>
                }
            </div>
        ); 
    }
}


